import clsx from "clsx";

import { Button, CircularProgress, Input, Skeleton, Stack, Typography } from "@mui/material";

type TUploadDataButtonProps = {
	className?: string;
	disabled?: boolean;
	uploading?: boolean;
	loading?: boolean;
	title?: string;
	accept?: string;
	sx?: Object;
	labelSx?: Object;
	titleSx?: Object;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function UploadDataButton(props: Readonly<TUploadDataButtonProps>) {
	const { className = "" } = props;

	return (
		<label htmlFor="upload-data-button" style={props.labelSx}>
			<Input
				id="upload-data-button"
				type="file"
				style={{ display: "none" }}
				disabled={props.disabled || props.uploading}
				inputProps={{ accept: props.accept ?? "*" }}
				onChange={props.onChange}
			/>
			<Button
				variant="contained"
				component="span"
				className={clsx({
					"!shadow-none": true,
					[className]: true,
				})}
				sx={props.sx}
				disabled={props.disabled || props.uploading}
			>
				{props.loading ? (
					<Skeleton variant="rectangular" height={30} width={140} sx={{ borderRadius: "6px" }} />
				) : (
					<>
						{props.uploading ? (
							<Stack>
								<CircularProgress color="inherit" size={20} />
							</Stack>
						) : (
							<Typography
								sx={props.titleSx}
								className="btn-regular-text !capitalize !font-[Montserrat] !text-[14.5px] !shadow-none"
							>
								{props.title ?? "Upload"}
							</Typography>
						)}
					</>
				)}
			</Button>
		</label>
	);
}
